/**
 * 弹框切换包装
 * 打开弹框的时候，会自动传入一个 onSwitch 方法， 弹框内部可调用 onSwtich 进行切换弹框
 * @param {Modal[]} modals 弹框集合 一般第一个是主弹框，后面几个是附属弹框
 * @returns {{
 *  open: (props: object， target?: number | 0)=> {update:(object)=>void, destroy: ()=void, switch: switchModal}
 * }}
 *
 * @example 具体实例可参考 画板删除确认弹框切换的应用
 *
 * open 默认打开第一个弹框，可通过传入target指定打开第几个弹框
 * switch 切换制定的弹框
 */
export default function SwitchModalWrap(modals) {
  return {
    open: (props) => {
      const mainModal = modals[0];
      let activeModal = null;
      const modalIns = [];
      /**
       * 切换弹框
       * @param {number} target 要切换的目标弹框
       * @param {object} props
       */
      function switchModal(target, props = {}) {
        if (activeModal) {
          activeModal.close();
        }
        if (modalIns[target]) {
          activeModal = modalIns[target];
          modalIns[target].open({
            ...props,
          });
        } else {
          const ins = modals[target].open({ ...props, onSwitch: switchModal });
          modalIns[target] = ins;
          activeModal = ins;
        }
      }

      activeModal = mainModal.open({ ...props, onSwitch: switchModal });

      modalIns.push(activeModal);

      return {
        update(props) {
          activeModal.update(...props);
        },
        destroy() {
          // 遍历销毁
          modalIns.forEach((modal) => {
            modal?.destroy?.();
          });
        },
        switch: switchModal,
      };
    },
  };
}
